import {
  AD_REFRESH_TRIGGERS,
  AutorefreshConfig,
  BannerPlacementType,
  EmbedCodeBase,
} from './types';

export const SESSION_STORAGE_KEY = 'YandexFloorAdClosed';
export const AD_AUTOREFRESH_INTERVAL_MS = 30_000;

const OWNER_ID = 1463667;

const withOwnerId = (base: Omit<EmbedCodeBase, 'ownerId'>): EmbedCodeBase => ({
  ...base,
  ownerId: OWNER_ID,
});

export const FloorAdCodes: Record<AdFox.PlatformType, EmbedCodeBase> = {
  desktop: withOwnerId({
    params: {p1: 'dfjtk', p2: 'jiik'},
    platform: 'desktop',
    type: 'floorAd',
  }),
  touch: withOwnerId({
    params: {p1: 'dfjtj', p2: 'jiij'},
    platform: 'touch',
    type: 'floorAd',
  }),
};

export const BannerCodes: Record<BannerPlacementType, EmbedCodeBase> = {
  floor_ad_banner: withOwnerId({
    params: {p1: 'dfjtl', p2: 'jiil'},
  }),
  floor_ad_banner_scroll: withOwnerId({
    params: {p1: 'dhjtx', p2: 'jlns'},
  }),
  apps_list: withOwnerId({
    params: {p1: 'dfjto', p2: 'jiin'},
  }),
  app_card: withOwnerId({
    params: {p1: 'dfjtm', p2: 'jiim'},
  }),
  new_app_card: withOwnerId({
    params: {p1: 'dhjuj', p2: 'jlnt'},
  }),
  left_sidebar: withOwnerId({
    params: {p1: 'dfnoc', p2: 'jirk'},
  }),
  right_sidebar: withOwnerId({
    params: {p1: 'dfjue', p2: 'jiio'},
  }),
  interesting_apps_1: withOwnerId({
    params: {p1: 'dfjvx', p2: 'jiiw'},
  }),
  interesting_apps_2: withOwnerId({
    params: {p1: 'dfjvy', p2: 'jiix'},
  }),
  interesting_apps_3: withOwnerId({
    params: {p1: 'dfjvz', p2: 'jiiy'},
  }),
  interesting_apps_4: withOwnerId({
    params: {p1: 'dfjwb', p2: 'jiiz'},
  }),
  interesting_apps_5: withOwnerId({
    params: {p1: 'dfjwe', p2: 'jija'},
  }),
  interesting_apps_6: withOwnerId({
    params: {p1: 'dfjwo', p2: 'jijc'},
  }),
  interesting_apps_7: withOwnerId({
    params: {p1: 'dfnob', p2: 'jirj'},
  }),
  interesting_games_1: withOwnerId({
    params: {p1: 'dfjwq', p2: 'jijd'},
  }),
  interesting_games_2: withOwnerId({
    params: {p1: 'dfjwr', p2: 'jije'},
  }),
  interesting_games_3: withOwnerId({
    params: {p1: 'dfjwt', p2: 'jijf'},
  }),
  interesting_games_4: withOwnerId({
    params: {p1: 'dfjwu', p2: 'jijg'},
  }),
  interesting_games_5: withOwnerId({
    params: {p1: 'dfjwx', p2: 'jijh'},
  }),
  interesting_games_6: withOwnerId({
    params: {p1: 'dfjwy', p2: 'jijj'},
  }),
  interesting_games_7: withOwnerId({
    params: {p1: 'dfnoe', p2: 'jirl'},
  }),
  search: withOwnerId({
    params: {p1: 'dhlnw', p2: 'jlrm'},
  }),
  categories_desktop: withOwnerId({
    params: {p1: 'dhlrd', p2: 'jlrw'},
  }),
  categories_mob: withOwnerId({
    params: {p1: 'dhlrg', p2: 'jlrx'},
  }),
  inread_blog: withOwnerId({params: {p1: 'dhwee', p2: 'jmjs'}}),
  instruction_step: withOwnerId({
    /* тут скопипасчено interesting_apps_1 ибо другого не дадут */
    params: {p1: 'dfjvx', p2: 'jiiw'},
  }),
};

export const defaultAutorefreshConfig: AutorefreshConfig = {
  triggers: [...AD_REFRESH_TRIGGERS],
  intervalMs: 30_000,
  logging: true,
};

export const FLOOR_AD_CONTAINER_ID = 'floor_ad';
